import { render, staticRenderFns } from "./LegacyRwImage.vue?vue&type=template&id=7ed74059"
import script from "./LegacyRwImage.vue?vue&type=script&lang=js"
export * from "./LegacyRwImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/indsol-advisor/indsol-advisor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed74059')) {
      api.createRecord('7ed74059', component.options)
    } else {
      api.reload('7ed74059', component.options)
    }
    module.hot.accept("./LegacyRwImage.vue?vue&type=template&id=7ed74059", function () {
      api.rerender('7ed74059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LegacyRwImage.vue"
export default component.exports